module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2z"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('em', [_vm._v("2")])])]), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('em', [_vm._v("Spice Blends "), _c('span', {
    staticClass: "small"
  }, [_vm._v("and")]), _vm._v(" Seasonings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fortunately, the number of salt-free seasoning blends has increased in the past few years. Major spice companies like McCormick now make a number of salt-free blends (look for the bottles with the green caps). Other organic and specialty suppliers make only salt-free seasonings. However, you may not be able to find the spice you are looking for in a salt-free version. Or perhaps you are just out when you needed some. In those cases, making your own spice blends is a simple solution. We have in this chapter a wide variety. You probably won’t use all of them. But I hope you discover a few favorites.")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("No-Salt Seasoning")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This is one of my favorite variations of a no-salt seasoning mix. It is particularly good with red meats or in soups. The lemon also makes it a good choice for fish.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 ½ teaspoons garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons white pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons dried lemon peel")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ¼ teaspoons black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 46 servings (¼ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 1 calorie (19% from fat, 15% from protein, 66% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 0 g carb; 0 g fiber; 0 g sugar; 3 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 5 mg potassium; 34 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" Use on meats, poultry, and fish.")])])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Dick’s Salt-Free Seasoning")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This blend is my attempt to approximate the flavors in the typical seasoned salt blends like Lawry’s, without the sodium. It is the latest in a number of variations, and I believe it captures the flavors of the herbs and spices typically used. Use it anywhere seasoned salt is called for or when you want to give food a little extra flavor. I particularly like it in soups and egg dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon coriander")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 22 servings (¼ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 2 calories (28% from fat, 11% from protein, 60% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 0 g carb; 0 g fiber; 0 g sugar; 2 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 10 mg potassium; 90 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Chili Powder")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("If you can’t find salt-free chili powder … or if you just like experimenting … you can easily make your own. Vary the amount of cayenne to match your own idea of how hot chili should be.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("3 teaspoons (7.5 g) paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (2 g) dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 14 servings (about 1 teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 7 calories (27% from fat, 14% from protein, 58% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 1 g fiber; 0 g sugar; 7 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 47 mg potassium; 805 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Curry Powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("You can easily fashion your own curry powder to your taste rather than having to be satisfied with what you find on your grocer’s shelves. This makes a medium-hot powder, but you can adjust the heat and the proportions of the seasonings however you prefer.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (4 g) black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon bay leaf, ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (5 g) chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("4 teaspoons (8 g) coriander")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (5 g) cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("4 teaspoons (12 g) garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon ground allspice")])]), _c('p', {
    staticClass: "noindentr"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("2 teaspoons (5 g) paprika")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindentr"
  }, [_vm._v("4 teaspoons (8.8 g) turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 32 servings (1 teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" Each with: 0 g water; 6 calories (23% from fat, 14% from protein, 63% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 8 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("2 mg sodium")]), _vm._v("; 34 mg potassium; 157 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Mexican Seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Add to chili, beans, or other Mexican dishes or sprinkle on grilled vegetables like potatoes or onions.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon dried chile peppers, ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon bay leaf, ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 11 servings (1 teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 7 calories (20% from fat, 14% from protein, 65% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 10 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 28 mg potassium; 193 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Oriental Seasoning")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Add to stir-fries. Also good in salad dressings and dips.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (5.4 g) sesame seeds, roasted")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried onion flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried lemon peel")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon bell pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 38 servings (½ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 4 calories (49% from fat, 13% from protein, 38% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 0 g carb; 0 g fiber; 0 g sugar; 7 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 9 mg potassium; 1 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("New Bay Seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Here in Maryland, summer means crabs and other seafood. And seafood means steamed, with Old Bay Seasoning or the locally produced equivalent from the local seafood market. Only trouble is Old Bay contains 330 mg of sodium per 1/2 teaspoon. So next time you want some steamed seafood, use our low sodium taste-alike substitute.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon bay leaf, ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon cardamom")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon cloves, ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon mace")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 18 servings (¼ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 3 calories (33% from fat, 14% from protein, 53% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 9 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 14 mg potassium; 70 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Taco Seasoning Mix")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Several brands of salt-free taco seasoning mix are available, but they aren’t always easy to find. Fortunately, it’s not difficult to make up your own.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (5 g) chili powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) all-purpose flour")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (5 g) cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (2 g) dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Combine all ingredients in a resealable plastic bag and shake until completely mixed. Add to browned ground beef along with ½ to ¾ cup (120 to 175 ml) water and cook until reduced to desired consistency.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 6 servings (½ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 1 g water; 23 calories (23% from fat, 12% from protein, 65% from carb); 1 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 4 g carb; 1 g fiber; 0 g sugar; 20 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("5 mg sodium")]), _vm._v("; 76 mg potassium; 834 IU vitamin A; 2 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Grill Blend")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This mixture is good sprinkled on any kind of meat or vegetables before grilling.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (2.4 g) dried chile peppers, ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_c('span', {
    staticClass: "ent"
  }, [_vm._v("⅛")]), _vm._v(" teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 13 servings (1 teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 5 calories (13% from fat, 14% from protein, 72% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 4 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 24 mg potassium; 197 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Memphis Rub")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("A flavorful dry rub for grilled chicken and other meats.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("¼ cup (28 g) paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 g) brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (4 g) cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dry mustard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon onion powder")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Combine all the ingredients in a jar, twist the lid on tightly, and shake to mix. Store away from heat or light for up to 6 months.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 11 servings (1 tablespoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 28 calories (16% from fat, 8% from protein, 76% from carb); 1 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 6 g carb; 1 g fiber; 4 g sugar; 21 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("3 mg sodium")]), _vm._v("; 94 mg potassium; 1458 IU vitamin A; 2 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Steakhouse Spice Rub")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("To give your grilled steaks that steakhouse flavor (without the added salt), rub them with this mixture before putting them on the grill. The sugar helps to create that crispy outer crust and seal in all the juices.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (6 g) onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (4 g) garlic pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (10 g) brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon black pepper, freshly ground")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix together and rub into meat before cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 4 servings (about 2 teaspoons)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 19 calories (2% from fat, 8% from protein, 90% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 5 g carb; 0 g fiber; 3 g sugar; 10 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("2 mg sodium")]), _vm._v("; 41 mg potassium; 2 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Seafood Boil Blend")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Use this blend when boiling or steaming seafood or fish.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon mustard seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (4 g) dill seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried chile peppers, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon bay leaf, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground allspice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container. Makes enough to boil 4 to 8 helpings of seafood.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 6 servings")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 1 g water; 14 calories (41% from fat, 17% from protein, 43% from carb); 1 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 2 g carb; 1 g fiber; 0 g sugar; 29 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 33 mg potassium; 44 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" Because this mixture contains whole seeds, it is not as useful to put directly on food.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Cajun Seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Add a little Cajun flavor to your favorite dishes. But leave out the sodium that almost all commercial Cajun seasonings contain.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 ½ teaspoons (3 g) dried onion flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) minced garlic")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon marjoram")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon fennel")])]), _c('p', {
    staticClass: "noindentr1"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("1 teaspoon cumin")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 24 servings (½ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 3 calories (22% from fat, 14% from protein, 65% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 4 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 14 mg potassium; 172 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Not Quite Emeril’s Creole Seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Creole is more of an “in-town,” upper-class cuisine than Cajun. With its French influence, it tends to have a more complex blend of flavors, with less reliance on the heat of cayenne pepper. This seasoning mix will still give your recipes some kick, but also a lot of flavor. The basic ingredients are based on Emeril’s recipe for Creole seasoning, but modified to my taste and without the salt.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("½ teaspoons (3.8 g) paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¾ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings (about 1 tablespoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 1 g water; 19 calories (19% from fat, 14% from protein, 67% from carb); 1 g protein; 1 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 4 g carb; 2 g fiber; 1 g sugar; 25 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("2 mg sodium")]), _vm._v("; 103 mg potassium; 1455 IU vitamin A; 3 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Cajun Blackening Spice Mix")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Use this mixture to make blackened fish or chicken.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("5 teaspoons (12.5 g) paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon white pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings (about 1 teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 7 calories (25% from fat, 14% from protein, 61% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 1 g fiber; 0 g sugar; 8 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 45 mg potassium; 864 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Greek Seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This will add a Greek flavor to almost any dish. I particularly like it in stews and egg dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 ½ teaspoons onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cornstarch")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon low sodium beef bouillon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon dried parsley flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 8 servings (1 teaspoon)")])]), _c('p', {
    staticClass: "noindentn"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('strong', [_vm._v("Nutritional Analysis")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 8 calories (13% from fat, 11% from protein, 76% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 2 g carb; 0 g fiber; 0 g sugar; 7 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("4 mg sodium")]), _vm._v("; 17 mg potassium; 8 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Jerk Seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Not as hot as some jerk seasonings you may have had, but hot enough to be interesting.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon onion flakes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (2 g) dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon ground allspice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon ground nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("¼ teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (9 g) sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (1 g) dried chives")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix together all the ingredients. Store in a tightly closed glass jar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 12 servings (about ½ tablespoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 8 calories (8% from fat, 7% from protein, 85% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 2 g carb; 0 g fiber; 1 g sugar; 9 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 21 mg potassium; 77 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" To make an authentic, very hot jerk blend, use powdered Scotch bonnet peppers instead of the cayenne.")])])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Jamaican Blend")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Add a taste of the islands to grilled food or mix into rice or egg dishes. Sweeter and not as hot as the jerk seasoning.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (6 g) onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (6 g) garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground allspice")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon dried chives")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon bay leaf, crushed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings (about ½ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 3 calories (12% from fat, 12% from protein, 75% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 3 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("0 mg sodium")]), _vm._v("; 10 mg potassium; 25 IU vitamin A; 0 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Garam Masala")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("This is a classic Indian spice mix that can be used in place of curry powder. If you can’t find the whole seeds you can use the ground spice.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("2 teaspoons (3.4 g) black peppercorns")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon whole cloves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("3 inches (7.5 cm) cinnamon stick")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cumin seeds")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon coriander seeds")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 ½ teaspoons cardamom")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Mix all ingredients and lightly roast in an ungreased skillet. Grind in a food processor until a fine powder forms.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 16 servings (about ½ tablespoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 7 calories (26% from fat, 11% from protein, 63% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 1 g fiber; 0 g sugar; 14 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("2 mg sodium")]), _vm._v("; 30 mg potassium; 16 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Tandoori Masala")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Use this Indian-flavored mix to rub on fish or chicken before grilling.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon coriander")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 6 servings (½ tablespoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 7 calories (38% from fat, 15% from protein, 47% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 14 mg calcium; 1 mg iron; "), _c('strong', [_vm._v("3 mg sodium")]), _vm._v("; 49 mg potassium; 398 IU vitamin A; 2 mg vitamin C; 0 mg cholesterol")])]), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Indian Curry Blend")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Adds a great flavor to vegetable or rice dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr1"
  }, [_vm._v("1 teaspoon turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon coriander")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("2 teaspoons (5 g) paprika")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("1 teaspoon ground ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon cloves")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon celery seed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("½ teaspoon cayenne pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Mix all the ingredients together. Store in an airtight container.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Yield:")]), _vm._v(" 24 servings (about ½ teaspoon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('strong', [_vm._v("Nutritional Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentn1"
  }, [_c('strong', [_vm._v("Each with:")]), _vm._v(" 0 g water; 3 calories (28% from fat, 13% from protein, 59% from carb); 0 g protein; 0 g total fat; 0 g saturated fat; 0 g monounsaturated fat; 0 g polyunsaturated fat; 1 g carb; 0 g fiber; 0 g sugar; 4 mg calcium; 0 mg iron; "), _c('strong', [_vm._v("1 mg sodium")]), _vm._v("; 20 mg potassium; 122 IU vitamin A; 1 mg vitamin C; 0 mg cholesterol")]), _vm._v(" "), _c('div', {
    staticClass: "sidebar1"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('strong', [_vm._v("Tip:")]), _vm._v(" Moderately hot; adjust the amount of cayenne to your taste.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 72
// module chunks = 0